export function formatCurrency(value: number | string, min?: number, max?: number) {
  const numValue: number = typeof value === "string" ? Number(value) : value;
  return new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: min || 0,
    maximumFractionDigits: max || 0,
  }).format(numValue);
}
